import { Injectable } from "@angular/core";

@Injectable()
export class HttpErrorDialogService {
	public static errorDialogComponentCallback: any;
}